module.exports = __webpack_public_path__ + "static/media/landmark.a6183353.svg";